export var hardBreak = {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [{ tag: 'br' }],
    toDOM: function () {
        return ['br'];
    },
};
//# sourceMappingURL=hard-break.js.map